import React from 'react';
import { Modal } from 'react-bootstrap'
import CambiarContrasena from './CambiarContrasena'

class CambiarContrasenaModal extends React.Component {
    render() {
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Cambiar Contraseña
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CambiarContrasena userToken={this.props.userToken} email={this.props.email}/>
                </Modal.Body>
            </Modal>
        );
    }
}

export default CambiarContrasenaModal;